// removed by extract-text-webpack-plugin
module.exports = {"popoverZIndex":"19","popoverOZIndex":"21","divider":"PartnershipBlockMobile__divider___3gVNv","gm-style-iw":"PartnershipBlockMobile__gm-style-iw___1uDDE","partnershipBlockMobile":"PartnershipBlockMobile__partnershipBlockMobile___ViHGe","header":"PartnershipBlockMobile__header___2PWvy","incomeBlock":"PartnershipBlockMobile__incomeBlock___3IXVf","registerBtn":"PartnershipBlockMobile__registerBtn___3eVvG"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PartnershipBlock/PartnershipBlockMobile.scss
 ** module id = 1111
 ** module chunks = 0
 **/